import type { ElementDefinition } from 'shared/elements-definition';
import basicHtml from './stories/basic.story.html?raw';
import advancedHtml from './stories/advanced.story.html?raw';

import { accordionPropsDocs, accordionItemPropsDocs } from './Accordion.props';

/**
 * Docs definition for the Accordion component and its custom elements.
 *
 * Used by the docs site to render:
 * - API tables for `<e-accordion>` and `<e-accordion-item>`
 * - Example stories in the code playground
 */
export const definition: ElementDefinition = {
  componentName: 'Accordion',
  description:
    'An accordion is a vertically stacked list of items that can be expanded or collapsed to show or hide content.',
  elements: [
    {
      tag: 'e-accordion',
      description: 'Container for accordion items.',
      props: Object.values(accordionPropsDocs),
      styling: [
        {
          name: '--e-accordion-gap',
          kind: 'css-variable',
          description: 'Controls the vertical spacing between items.'
        }
      ]
    },
    {
      tag: 'e-accordion-item',
      description: 'Single accordion item.',
      props: Object.values(accordionItemPropsDocs),
      styling: [
        {
          name: '::part(header)',
          kind: 'part',
          description: 'Styles the header (button) of the item.'
        },
        {
          name: '::part(content)',
          kind: 'part',
          description: 'Styles the content area of the item.'
        }
      ]
    }
  ],

  stories: [
    {
      id: 'basic',
      name: 'Basic',
      description: 'A basic accordion with multiple items.',
      html: basicHtml
    },
    {
      id: 'advanced',
      name: 'Advanced',
      description: 'An advanced accordion with additional features.',
      html: advancedHtml
    }
  ]
};
